export default [
    {
        field   : 'invoice_number',
        type    : 'text',
        flex    : {
            md2 : true,
        },
        vuetifyProps: {
            label   : 'N° de factura',
        },
        rules   : [ 'required', 'numeric' ],
        value   : '',
    },
    {
        field   : 'pch_provider_id',
        type    : 'autocompleteObject',
        flex    : {
            md4 : true,
        },
        options: {
            data    : [],
            text    : 'alias_name',
            value   : 'id',
        },
        vuetifyProps: {
            label   : 'Proveedor',
        },
        rules   : [ 'required' ],
        value   : '',
    },
    {
        field   : 'pch_provider_branch_offices_id',
        type    : 'autocompleteObject',
        flex    : {
            md3 : true,
        },
        options: {
            data    : [],
            text    : 'address',
            value   : 'id',
        },
        vuetifyProps: {
            label: 'Sucursal del proveedor',
        },
        rules   : [ 'required' ],
    },
    {
        field   : 'emission_date',
        type    : 'datePicker',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label   : 'Fecha emisión',
        },
        rules   : ['required'],
        customRules: [ 'dateRule' ],
        value   : '',
    },
    {
        field   : 'payment_date',
        type    : 'datePicker',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: 'Fecha Pago',
        },
        rules   : ['required'],
        customRules: ['dateRule'],
        value   : '',
    },
    {
        field   : 'pch_payment_condition_id',
        type    : 'autocompleteObject',
        flex    : {
            md3 : true,
        },
        options: {
            data: [],
            text: 'type',
            value: 'id',
        },
        vuetifyProps: {
            label: 'Método pago',
        },
        rules: [ 'required' ],
        value   : '',
    },
    {
        field: 'acc_cost_center_id',
        type: 'autocompleteObject',
        flex    : {
            md6 : true,
        },
        vuetifyProps: {
            label: 'Centro de costos',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'payable',
        type: 'checkbox',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: 'Bloquear Pago',
            'false-value': true,
            'true-value': false,
        },
        value: true,
    },
    {
        field   : 'is_exent',
        type    : 'checkbox',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: '¿Factura es exenta?',
        },
        value   : false,
    },
    {
        field: 'new_subtotal',
        type: 'text',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: 'Neto',
        },
        rules: ['required'],
        format: 'currency',
        value: '',
    },
    {
        field: 'iva',
        type: 'text',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: 'IVA',
        },
        rules: ['required'],
        format: 'currency',
        value: '',
    },
    {
        flex    : {
            md9 : true,
        },
    },
    {
        field: 'total',
        type: 'text',
        flex    : {
            md3 : true,
        },
        vuetifyProps: {
            label: 'Total',
        },
        rules: ['required'],
        format: 'currency',
        value: '',
    },
]
